import React from 'react';
import Image from '../images';

import './FileUpload.scss';

const FileUpload = ({ onChange, inputRef, successText }) => {
  return (
    <label className="FileUpload">
      <div>
        <p>Drag and drop to upload or</p>
        <b>
          Browse <Image type="Browse" />
        </b>
        <span className={successText ? 'success' : ''}>{successText ? successText : 'Support csv, xlsx'}</span>
      </div>
      <input type="file" accept=".csv, .xlsx, .xls" onChange={onChange} ref={inputRef} style={{ display: 'none' }} />
    </label>
  );
};

export default FileUpload;
